/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import autobind from "autobind-decorator";
import React, {Fragment} from "react";
import {Col, InputGroup, Row} from "react-bootstrap";

export class OptionEditor extends BaseFieldEditor {
	@autobind
	_render() {
		const {Value, FieldDef, OnUpdate} = this.props;

		return <Fragment>
			{
				Object.keys(FieldDef?.customData).map(x =>
					<Row key={x}>
						<Col xs={4}>
							<InputGroup.Checkbox
								style={{margin: 0}}
								checked={Value == x}
								onChange={_ => Value == x ? OnUpdate?.(null) : OnUpdate?.(x)}
							/>
						</Col>
						<Col xs={8}>
							{FieldDef?.customData[x]}
						</Col>
					</Row>
				)
			}
		</Fragment>
	}
}